/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, InputNumber, Modal, Select, Input} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, objectSerial, config} from 'Utils';
import {materialScreening2} from '../../service/inventoryQuery';
import {
    getStockList,
    setProductUp,
    setProductDown,
    getProductCategory,
    getSubStoreList,
    tiaozhengAdd,
    createSafetyStore,
    deleteAllId,
    setAllId,
    reSetAll,
    getProductListIds,
    insertAll
} from '../../service/product';
import {Store, Actions} from './store';

const Option = Select.Option;
const confirm = Modal.confirm;

class StockControlList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            opts: ['安全库存设置'],
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            selectedRowKeys2: [],
            selectedRows2: [],
            rows: [],
            visible: false,
            total: 1,
            saveVisible: false,
            upLineNum: 0,
            downLineNum: 0,
            id: '',
            transferVisible: true,
            tiaozheng: [{id: '', count: ''}],
            stockFlag: '',
            searchObj: {
                saftStoreFlag: 1,
                subStoreId: '',
                name: '',
                type: '',
                s: 10,
                p: 1,
            },
            objType_type: [],
            objType_type2: [],
            button_limits_end: {},
            visible2: false,
            targetStore: [],
            addTotal: 1,
            dataSource2: [],
            addSearchObj: {
                name: '',
                code: '',
                s: 5,
                p: 1
            },
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.changeHandle = this.changeHandle.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.exportChange = this.exportChange.bind(this);
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        // console.log(selectedRowKeys);
        // console.log(selectedRows);
        this.setState({selectedRowKeys});
    }

    goView(url) {
        hashHistory.push(url);
    }

    goAdd() {
        let self = this;
        tiaozhengAdd(this.state.tiaozheng).then((result) => {
            if (result && result.code == 200) {
                openNotice('success', (result && result.message) ? result.message : '', '');
                self.initData();
            } else {
                openNotice('error', (result && result.message) ? result.message : '', '');
            }
        })
        this.setState({saveVisible: !this.state.saveVisible});
    }

    goChange() {
        this.setState({saveVisible: true, transferVisible: false});

    }

    changeAmount = (record, e) => {
        // if (e.target.value < 0){
        // 	openNotice('warning', '数量不能为负数！');
        // 	return;
        // } else if (record.count < e.target.value) {
        // 	openNotice('warning', '调整库存不能大于现有量！');
        // 	return;
        // } else {
        let arr = [];
        let obj = {};
        obj.id = record.id;
        obj.count = e.target.value;
        arr.push(obj);
        this.setState({tiaozheng: arr});
        // }
    }

    goDelete() {
        alert('正在删除');
    }

    changeHandle({item, key, keyPath}) {
        this.setState({key});
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                subStoreId: '',
                name: '',
                type: '',
                stockFlag: '',
                s: 10,
                p: 1,
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1,
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}})
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        getStockList(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    loading: false
                });
            } else {
                openNotice('error', '数据获取失败', '');
                this.setState({loading: false});
            }
        });
    }

    /*选择物料-物料编码搜索*/
    codeChange = (event) => {
        this.setState({
            code: event.target.value
        });
    };
    /*选择物料-物料名称搜索*/
    nameChange = (event) => {
        this.setState({
            name: event.target.value
        });
    };

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        let self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params,
                },
                key: data.params.buyerStatus || 0
            });
        }
        getSubStoreList({
            removeFlag: 0,
            s: 1000,
            p: 1,
        }).then(res => {
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.subStoreName,
                        value: x.id
                    })
                });
                self.setState({objType_type: arr})
            }
        });
    }

    componentDidMount() {
        this.initData();
        getSubStoreList({
            removeFlag: 0,
            s: 10,
            p: 1,
        }).then((result) => {
            if (result && result.code == 200) {
                this.setState({
                    // store: result.data || [],
                    targetStore: result.data || [],
                    total: result.total,
                    // userName: user.userName
                })
            } else {
                openNotice('error', '数据获取失败', '');
            }
        })
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    changeStorage = (record) => {
        this.setState({
            upLineNum: record.storeMax || 0,
            downLineNum: record.storeMin || 0,
            visible: true,
            id: record.id
        })
    }
    upLine = (record, index, e) => {
        const self = this;
        var rows = [...this.state.rows];
        // this.setState({ upLineNum: e.target.value });
        if (e < record.storeMin) {
            return
        }
        setAllId({
            id: record.id,
            storeMax: e
        }).then(res => {
            if (res && res.code == 200) {
                // console.log(res);
                rows[index].storeMax = e;
                self.setState({rows: rows});
            }
        })
    }
    downLine = (record, index, e) => {
        const self = this;
        var rows = [...this.state.rows];
        if (e > record.storeMax || e == record.storeMax) {
            return
        }
        // this.setState({ downLineNum: e.target.value });
        setAllId({
            id: record.id,
            storeMin: e
        }).then(res => {
            if (res && res.code == 200) {
                // console.log(res);
                // console.log(res);
                rows[index].storeMin = e;
                self.setState({rows: rows});
            }
        })
    }
    handleS = () => {
        createSafetyStore({id: this.state.id}).then((result) => {
            if (result && result.code == 200) {
                this.setState({id: '', upLineNum: 1, downLineNum: 0});
                openNotice('success', '设置成功', '');
                this.initData();
            } else {
                openNotice('error', '设置作失败', (result && result.message) ? result.message : '');
            }
        })
        this.setState({visible: false});
    }
    handleT = () => {
        let self = this;
        if (~~self.state.upLineNum < ~~self.state.downLineNum) {
            openNotice('warning', '请填写上限数量必须大于下限数量', '');
            return;
        }
        let obj = {
            id: self.state.id,
            storeMax: self.state.upLineNum,
            storeMin: self.state.downLineNum
        };
        createSafetyStore(obj).then((result) => {
            if (result && result.code == 200) {
                self.setState({id: '', upLineNum: 1, downLineNum: 0});
                openNotice('success', '设置成功', '');
                self.initData();
            } else {
                openNotice('error', '设置失败', (result && result.message) ? result.message : '');
            }
        })
        this.setState({visible: false});
    }

    handleF = () => {
        this.setState({visible: false});
    }
    deleteAll = () => {
        deleteAllId(this.state.selectedRowKeys).then(res => {
            if (res.code == 200 && res) {
                console.log(res);
            }
        })
        this.initData();
        this.setState({selectedRowKeys: []});
    }

    setAll = () => {
        var selectedRowKeys = [...this.state.selectedRowKeys];
        if (selectedRowKeys.length == 0) {
            return
        } else {
            var a = [];
            for (var i = 0; i < selectedRowKeys.length; i++) {
                var b = {};
                b.id = selectedRowKeys[i];
                b.storeMax = null;
                b.storeMin = null;
                a.push(b);
            }
            reSetAll(a).then(res => {
                if (res && res.code == 200) {
                    console.log(res)
                }
            })
            this.initData();
            this.setState({selectedRowKeys: []});
        }
    }

    addAll = () => {
        this.setState({visible2: true})
    }

    onOkModal() {
        const self = this;
        let selectedRowKeys2 = [...self.state.selectedRowKeys2];
        // let selectedRow2 = [...this.state.selectedRows2];
        var c = [];
        for (let u = 0; u < selectedRowKeys2.length; u++) {
            // debugger
            // console.log(selectedRows2);
            var d = {
                proId: selectedRowKeys2[u] || '',
                subStoreId: self.state.storageLocal || '',
                proType: self.state.selectedRows2[u].type || ''
            }
            // debugger
            c.push(d);
        }
        // console.log(c);
        // debugger
        insertAll(c).then(res => {
            if (res && res.code == 200) {
                openNotice('success', '添加安全库存成功');
                self.setState({visible2: false, selectedRowKeys2: [], selectedRows2: []});
                self.initData();
            } else {
                openNotice('error', '添加安全库存失败')
            }
        })
        self.setState({visible2: false, selectedRowKeys2: [], selectedRows2: []})

    }

    onCancelModal = () => {
        this.setState({visible2: false, selectedRowKeys2: [], selectedRows2: []})
    }
    changeTargetStore = (value) => {
        const self = this;
        self.setState({dataSource2: [], storageLocal: value.key});
    }

    poductList = () => {
        this.productListIds();
    }

    productListIds = () => {
        const {addSearchObj} = this.state;
        addSearchObj.substoreId = this.state.storageLocal || '';
        addSearchObj.name = this.state.name || '';
        addSearchObj.code = this.state.code || '';
        getProductListIds(addSearchObj).then((result) => {
            if (result && result.code == 200) {
                this.setState({
                    addRows: result.data || [],
                    addTotal: result.total
                });
            }
        })
    }
    addPageChange = (page) => {
        this.setState({
            addSearchObj: {...this.state.addSearchObj, p: page},
            selectedRowKeys2: [],
            selectedRows2: [],
        }, () => {
            this.productListIds();
        });
    }
    onSelectChange2 = (selectedRowKeys, selectedRows) => {
        // console.log(selectedRows);
        this.setState({selectedRowKeys2: selectedRowKeys, selectedRows2: selectedRows});
    }
    addSave = (record, index, value) => {
        const self = this;
        var a = [];
        var b = {};
        b.proId = record.id;
        b.proType = record.type;
        b.subStoreId = this.state.storageLocal;
        a.push(b);
        insertAll(a).then(res => {
            if (res && res.code == 200) {
                openNotice('success', '添加安全库存成功');
                self.setState({visible2: false});
                self.initData();
            } else {
                openNotice('error', '添加安全库存失败')
            }
        })
    }
    // addAllTings = () => {


    // }
    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/dmsTianGoodsStore/exportSafetyStock?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    render() {
        const {
            opts, key, visible, visible2, rows, total, searchObj, saveVisible, transferVisible,
            upLineNum, downLineNum, objType_type2, addSearchObj, addRows,
            selectedRowKeys, selectedRowKeys2, objType_type, button_limits_end, targetStore, addTotal, dataSource2, loading
        } = this.state;
        const addProps = {
            rowKey: 'id',
            loading: loading,
            pageParam: {
                total: addTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'code',
                    width: 100,
                }, {
                    title: '物料描述',
                    dataIndex: 'name',
                    width: 100
                }, {
                    title: '供应商',
                    dataIndex: 'supplier',

                }, {
                    title: '物料类别',
                    dataIndex: 'proType',
                }, {
                    title: '单位',
                    dataIndex: 'unit'
                }, {
                    title: '装箱数',
                    dataIndex: 'packageQuantity',

                }, {
                    title: '价格',
                    dataIndex: 'showPrice',
                    render: text => <span style={{color: '#d61518'}}>{'¥' + text}</span>
                }, {
                    title: '是否生效',
                    dataIndex: 'takeEffect',
                    render: text => text == 'Y' ? <span>是</span> : <span>否</span>
                }, {
                    title: '备注',
                    dataIndex: 'remark',
                },
                {
                    title: '操作',
                    dataIndex: 'save',
                    width: 100,
                    render: (text, record, index) => (<Button style={{background: '#red'}} icon="plus"
                                                              onClick={this.addSave.bind(this, record, index)}>添加</Button>)
                }
                // , {
                //   title: '创建时间',
                //   dataIndex: 'createdDate',
                // }//后端说没有
            ],
            rows: addRows,
            rowSelection: {
                selectedRowKeys2,
                onChange: this.onSelectChange2,
                // getCheckboxProps: record=>({
                //   disabled: ids.includes(record.id)
                // })
            }
        };
        const filterBoxProps = {
            fileds: [
                {
                    name: 'name',
                    label: '物料编号/描述',
                    text: '请输入物料编号/描述',
                    type: 'default',
                    labelStyle: {width: '150px'},
                    defaultValue: searchObj.name
                }, {
                    name: 'stockFlag',
                    label: '库存状态',
                    text: '选择库存状态',
                    //option:stockFlag,
                    options: [
                        {value: '', text: '全部'},
                        {value: 'H', text: '偏高'},
                        {value: 'L', text: '偏低'},
                        {value: 'N', text: '正常'},
                    ],
                    defaultValue: searchObj.stockFlag,
                    multiple: false,//支持多选
                    type: 'select',
                }, {
                    name: 'subStoreId',
                    label: '子库存',
                    text: '选择子库存',
                    options: objType_type,
                    defaultValue: searchObj.subStoreId,
                    multiple: false,//支持多选
                    type: 'select'
                }, {
                    name: 'type',
                    label: '物料类型',
                    text: '选择物料类型',
                    defaultValue: searchObj.type,
                    multiple: false,//支持多选
                    type: 'default'
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'code',
                    width: 120,
                }, {
                    title: '物料描述',
                    dataIndex: 'name',
                    width: 600
                }, {
                    title: '物料类别',
                    dataIndex: 'type',
                }, {
                    title: '单位',
                    dataIndex: 'unit',
                }, {
                    title: '现有量',
                    dataIndex: 'count',
                }, {
                    title: '子库存',
                    dataIndex: 'storageName'
                }, {
                    title: '库存状态',
                    dataIndex: 'stockFlag',
                    render: (text, record, index) => {
                        if (record.stockFlag == "L") {
                            return <span>偏低</span>
                        }
                        if (record.stockFlag == 'H') {
                            return <span>偏高</span>

                        }
                        if (record.stockFlag == 'N') {
                            return <span>正常</span>

                        }

                    }
                }, {
                    title: '库存上限',
                    dataIndex: 'storeMax',
                    render: (text, record, index) => {
                        return <InputNumber onChange={this.upLine.bind(this, record, index)}
                                            value={this.state.rows[index].storeMax} max={100000000000}/>
                    }
                }, {
                    title: '库存下限',
                    dataIndex: 'storeMin',
                    render: (text, record, index) => {
                        return <InputNumber onChange={this.downLine.bind(this, record, index)}
                                            value={this.state.rows[index].storeMin}/>
                    }
                },
                // {
                //   title: '操作',
                //   dataIndex: 'count1',
                //   render: (text, record, index) => {
                //     // return <Button onClick={this.changeStorage.bind(this, record)}>设置安全库存</Button>
                //     return <Button onClick={}>删除</Button>
                //   }
                // }

            ],
            rows,
            rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                // onSelect:this.onSelectRadio.bind(this),
                // type: 'radio',
                radio: false
            }
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}>
                {/* { <Button onClick={this.goAdd.bind(this)} style={{display: saveVisible ? 'inline-block' : 'none'}} >保存</Button>}
         { button_limits_end.stockControl_list_02 && <Button onClick={this.goChange.bind(this)} style={{display: saveVisible ? 'none' : 'inline-block'}}>库存调整</Button>}
         { button_limits_end.stockControl_list_03 && <Button onClick={this.goView.bind(this, '/stockControl/sublibraryTransfer')}>子库转移</Button>}
         { button_limits_end.stockControl_list_04 && <Button onClick={this.goView.bind(this, '/stockControl/sundryInStorage')}>杂项入库</Button>} */}
            </DmsTab>
            <div className="dms-table-box">
                <AdvanceFormNew  {...filterBoxProps} />
                <div className="dms-table-box">
                    <Button onClick={this.addAll.bind(this)}
                            style={{position: 'absolute', bottom: 8, left: 0}}>新增</Button>
                    <Button onClick={this.deleteAll.bind(this)}
                            style={{position: 'absolute', bottom: 8, left: 70}}>删除</Button>
                    {/*<Button onClick={this.setAll.bind(this)} style={{marginRight: '10px'}}
                            style={{position: 'absolute', bottom: 8, left: 140}}>重置</Button>*/}
                    <Button style={{position: 'absolute', bottom: 8, right: 2}} icon="export"
                            onClick={this.exportChange}>导出</Button>
                </div>
                <TableView {...tableViewProps} />
            </div>
            <Modal
                visible={visible}
                maskClosable={false}
                onOk={this.handleT}
                onCancel={this.handleF}
                footer={[
                    <Button key="back" type="ghost" onClick={this.handleF}>返 回</Button>,
                    // <Button key="reset" type="ghost" onClick={this.handleS}>重 置</Button>,
                    <Button key="submit" type="primary" onClick={this.handleT}>确 定</Button>,
                ]}
            >
                <DmsTab className="white-bg no-border" options={['设置安全库存']} defaultKey={0}/>
                <div className="approve_modal" style={{marginTop: '20px'}}>
                    <label>库存上限</label>
                    <div style={{paddingLeft: '100px'}}>
                        <input type='Number' onChange={this.upLine.bind(this)} value={upLineNum}/>
                    </div>
                </div>
                <div className="approve_modal" style={{marginTop: '20px'}}>
                    <label>库存下限</label>
                    <div style={{paddingLeft: '100px'}}>
                        <input type='Number' style={{textAlign: 'middle'}} onChange={this.downLine.bind(this)}
                               value={downLineNum}/>
                    </div>
                </div>
            </Modal>
            <Modal
                visible={visible2}
                maskClosable={false}
                // onOk={this.onOkModal}
                onCancel={this.onCancelModal}
                width={1000}
                footer={[
                    // <Button key="back" type="ghost" onClick={this.handleF}>返 回</Button>,
                    // <Button key="reset" type="ghost" onClick={this.handleS}>重 置</Button>,
                    <Button key="submit" type="primary" onClick={this.onOkModal.bind(this)}>确 定</Button>,
                ]}
            >
                <DmsTab className="white-bg no-border" options={['新增安全库存']} defaultKey={0}/>
                <div className="dms-table-box">
                    <label>物料编码：</label>
                    <Input style={{width: 200}} value={this.state.code}
                           onChange={this.codeChange}></Input>
                    <label style={{paddingLeft: '20px'}}>物料描述：</label>
                    <Input style={{width: 200}} value={this.state.name}
                           onChange={this.nameChange}></Input>
                    <label style={{paddingLeft: '20px'}}>子库存：</label>
                    <Select
                        labelInValue
                        onChange={this.changeTargetStore.bind(this)}
                        style={{width: 200}}
                    >
                        {targetStore.map(function (item) {
                            return <Select.Option key={item.id + ''}
                                                  value={item.id + ''}>{item.subStoreName}</Select.Option>
                        })}
                    </Select>
                    <Button style={{marginLeft: '20px'}} onClick={this.poductList.bind(this)}>搜索</Button>
                    <TableView {...addProps} bordered style={{marginTop: 10}}/>
                </div>
                {/*<div className="approve_modal" style={{ marginTop: '20px' }}>
          <label>库存下限</label>
          <div style={{ paddingLeft: '100px' }}>
            <input type='Number' style={{ textAlign: 'middle' }} onChange={this.downLine.bind(this)}
                   value={downLineNum} />
          </div>
        </div>*/}
            </Modal>
        </div>
    }
}
;
export default withRouter(StockControlList);


// WEBPACK FOOTER //
// ./src/routes/saferStorageSet/list.js